import { render, staticRenderFns } from "./StartCuppingModal.vue?vue&type=template&id=5a6d40cc&scoped=true"
import script from "./StartCuppingModal.vue?vue&type=script&lang=js"
export * from "./StartCuppingModal.vue?vue&type=script&lang=js"
import style0 from "./StartCuppingModal.vue?vue&type=style&index=0&id=5a6d40cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6d40cc",
  null
  
)

export default component.exports